import React from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./layout/Header";
import Sidebar from "./layout/Sidebar";

const drawerWidth = 0;

export default function AdminDashboard() {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => setMobileOpen((p) => !p);

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
            <Header onOpenNav={handleDrawerToggle} />
            <Sidebar mobileOpen={mobileOpen} onClose={handleDrawerToggle} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 0,
                    ml: { md: `${drawerWidth}px` },
                    height: "100vh",
                    overflow: "auto", // 👈 DAS IST DER FIX
                }}
            >
                <Toolbar />
                {/* <- HIER rendert die Kindroute aus MainApp */}
                <Outlet />
            </Box>
        </Box>
    );
}
